import { createActions } from 'redux-actions';

import { formatMessage } from '../../intl/intl';
import SettingsService from '../../services/SettingsService';
import appActions from './app-actions';
import EventActions from './event-actions';
import appStore from '../stores/app.store';
import { autoAcceptService } from 'features/settings-page/auto-accept';

const { getSettingsAction, setAutoAcceptAction } = createActions({
  GET_SETTINGS_ACTION: settings => ({
    settings,
  }),
  SET_AUTO_ACCEPT_ACTION: isAutoAcceptActive => ({ isAutoAcceptActive }),
});

const getSettings = () => async dispatch => {
  try {
    const { data: settings } = await SettingsService.getSettings();
    dispatch(getSettingsAction(settings));
  } catch (ex) {
    await appActions.handleCatch(ex)(dispatch);
  }
};

const setAutoAccept = isActive => async dispatch => {
  const activeMsgId = 'settings.autoAccept.message.success';
  const deactiveMsgId = 'settings.autoAccept.message.deactivate';
  const successMsgId = isActive ? activeMsgId : deactiveMsgId;
  const successMessage = formatMessage({ id: successMsgId });
  const partnerId = appStore.getPartnerId();
  try {
    await SettingsService.setAutoAccept(isActive);
    autoAcceptService.saveValue(isActive);
    dispatch(setAutoAcceptAction(isActive));
    appActions.openSnackBarSuccess(successMessage)(dispatch);
    if (isActive) EventActions.onChangeAutoAcceptOrders({ partnerId });
  } catch (ex) {
    await appActions.handleCatch(ex)(dispatch);
  }
};

export default {
  getSettings,
  getSettingsAction,
  setAutoAccept,
  setAutoAcceptAction,
};
